

<template>
  <div>
    <b-container class="my-2">
      <b-row>
        <b-col xl="8" class="py-2 my-auto">
          <b-button
            variant="primary"
            size="md"
            class="shadow my-1"
            v-on:click="goToManageDocuments()"
            v-b-tooltip.hover
            title="Go Back to the Document List"
          >
            <b-icon icon="chevron-compact-left"></b-icon>
            Go Back
          </b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm>
          <b-card class="my-2" header="Upload CSV File" footer-tag="footer">
            <vue-csv-import
              v-model="documents_new"
              :map-fields="['text']"
              :fileMimeTypes="mimeTypes"
            >
              <!-- Check if csv has headers -->
              <template slot="hasHeaders" slot-scope="{ headers, toggle }">
                <label>
                  <input
                    type="checkbox"
                    id="hasHeaders"
                    :value="headers"
                    @change="toggle"
                  />
                  Does your file contain headers?
                </label>
              </template>

              <!-- Incalid File Type Error -->
              <template slot="error">
                <b-alert show variant="danger"
                  >File type is invalid. Please select a .csv file.</b-alert
                >
              </template>

              <template slot="thead">
                <tr>
                  <th>Field required</th>
                  <th>Column in .csv file</th>
                </tr>
              </template>

              <template slot="next" slot-scope="{ load }">
                <b-button
                  variant="secondary"
                  class="shadow"
                  v-on:click.prevent="load"
                  >Upload File</b-button
                >
              </template>
            </vue-csv-import>

            <template #footer>
              <b-button
                variant="primary"
                class="float-right mx-1 shadow"
                :disabled="!documents_new"
                v-on:click="uploadDocuments(corpus_id)"
                v-b-tooltip.hover
                title="Replace Documents in Corpus with uploaded Documents"
              >
                <b-spinner v-show="status.showSpinner" small></b-spinner>
                Append Documents
              </b-button>

              <!-- <b-button
                variant="primary"
                class="float-right mx-1"
                v-b-tooltip.hover
                title="Add uploaded Documents to the Corpus"
              >
                Add Documents
              </b-button> -->
            </template>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import requestsMixin from "../mixins/requestsMixin";
import messagesMixin from "../mixins/messagesMixin";
import { VueCsvImport } from "vue-csv-import";

export default {
  name: "component-manage-documents-upload",
  mixins: [requestsMixin, messagesMixin],
  components: { VueCsvImport },
  props: { corpus_id: { type: String } },
  data() {
    return {
      mimeTypes: [
        "text/csv",
        "text/plain",
        "text/x-csv",
        "application/vnd.ms-excel",
      ],
      documents_new: null,

      // Variables used for tracking
      // the state of the component
      status: {
        showSpinner: false,
      },
    };
  },
  methods: {
    goToManageDocuments() {
      this.$router.push({
        name: "manage_documents",
      });
    },

    // Append documents to corpus
    uploadDocuments(corpus_id) {
      if (!!corpus_id) {
        // Start spinner
        new Promise((resolve) => {
          this.status.showSpinner = true; // Show spinner
          resolve(true);
        })
          // Fetch meta information about corpus
          .then(() => {
            return this.appendDocumentsToCorpus();
          })
          .then(() => {
            return new Promise((resolve) => {
              this.showToast(
                "Upload complete",
                "Documents were successfully added to corpus.",
                "success"
              );
              resolve(true);
            });
          })
          // Stop spinner
          .finally(() => {
            this.status.showSpinner = false; // Hide spinner
            setTimeout(() => this.$router.push({ name: "home" }), 2000);
          })
          // Shwow error message
          .catch((error) => {
            console.log(error);
            this.showToast(
              String(error.message),
              String(error.cause),
              "danger"
            );
          });
      }
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/manageDocumentUpload.vue